import { useState, useEffect, useRef } from 'react';
import { createReporte } from '../../../../services/reporteService';
import './Delito.css';
import imagen from '../../../../assets/imagen.webp';
import imageCompression from 'browser-image-compression';
import PopupMensaje from '../../../../iu/popupMensaje/PopupMensaje';
import { useUser } from '../../../../userContext';
import Loader from '../../../../iu/loader/loader';

//seccion: Conectate a C4
import chatVecinal from '../../../../assets/iconos_amarillos/chat vecinal.png';
import conectaTuCamara from '../../../../assets/iconos_amarillos/conecta tu camara.png';
//seccion: Demanda
import robo from '../../../../assets/iconos_amarillos/robo.png';
import ventaDeDroga from '../../../../assets/iconos_amarillos/venta de droga.png';
import extorsion from '../../../../assets/iconos_amarillos/extorsion.png';
//seccion: Servicio Policial
import reunionVecinal from '../../../../assets/iconos_amarillos/reunion vecinal.png';
import rondinesDeSeguridad from '../../../../assets/iconos_amarillos/rondines de seguridad.png';
import acompanamietoBancario from '../../../../assets/iconos_amarillos/acompañamiento bancario.png';
import vehiculosAbandonados from '../../../../assets/iconos_amarillos/vehiculo abandonado.png';
import solicitaUnaCamara from '../../../../assets/iconos_amarillos/solicita una camara.png';
//seccion: Otros
import otros from '../../../../assets/iconos_amarillos/otros.png';

// Leaflet imports
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix para iconos de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Componente para detectar clics en el mapa
function MapClickHandler({ onMapClick }) {
    useMapEvents({
        click(e) {
            onMapClick(e);
        },
    });
    return null;
}


const Delito = () => {
    const [loading, setLoading] = useState(false);
    const { isLogged, id, token, telefono } = useUser();
    const [tituloSeleccionado, setTituloSeleccionado] = useState('');
    const [mostrarInput, setMostrarInput] = useState(false);
    const [ubicacionTipo, setUbicacionTipo] = useState('actual'); // 'actual' o 'mapa'
    const [ubicacionActual, setUbicacionActual] = useState('');
    const [telefonoOp, setTelefonoOp] = useState('');
    const [mapaCoords, setMapaCoords] = useState(null); // { lat: 19.4326, lng: -99.1332 } para CDMX

    const descripcionRef = useRef(null);
    const otroDelitoRef = useRef(null);

    useEffect(() => {
        if (tituloSeleccionado === 'Otro') {
            setMostrarInput(true);
            setTitulo('');
            setTimeout(() => {
                otroDelitoRef.current?.focus();
            }, 100);
        } else if (tituloSeleccionado !== '') {
            setMostrarInput(false);
            setTitulo(tituloSeleccionado);
            setTimeout(() => {
                descripcionRef.current?.focus();
            }, 100);
        }
    }, [tituloSeleccionado]);


    const obtenerUbicacionActual = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const coords = position.coords;
                    setUbicacionActual(`Lat: ${coords.latitude}, Lng: ${coords.longitude}`);
                    setPopupMensaje('Ubicación obtenida correctamente');
                    setPopupKey(prev => prev + 1);
                },
                (error) => {
                    console.error('Error obteniendo ubicación:', error);
                    setPopupMensaje('No se pudo obtener la ubicación actual');
                    setPopupKey(prev => prev + 1);
                }
            );
        } else {
            setPopupMensaje('La geolocalización no es soportada por tu navegador');
            setPopupKey(prev => prev + 1);
        }
    };

    const handleMapClick = (e) => {
        const { lat, lng } = e.latlng;
        setMapaCoords({ lat, lng });
        setPopupMensaje(`Ubicación seleccionada: ${lat.toFixed(6)}, ${lng.toFixed(6)}`);
        setPopupKey(prev => prev + 1);
    };

    useEffect(() => {
        if (tituloSeleccionado === 'Otro') {
            setMostrarInput(true);
            setTitulo("");
        } else {
            setMostrarInput(false);
            setTitulo(tituloSeleccionado);
        }
    }, [tituloSeleccionado]);

    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [fotos, setFotos] = useState([]);
    const [previewFotos, setPreviewFotos] = useState([]);
    const [popupMensaje, setPopupMensaje] = useState('');
    const [popupKey, setPopupKey] = useState(0);


    const handleFileChange = async (e) => {
        if (e.target.files.length <= 3) {
            const files = e.target.files;
            const compressedFiles = [];
            const filePreviews = [];

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                // Opciones de compresión
                const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1024,
                    useWebWorker: true
                };

                try {
                    const compressedFile = await imageCompression(file, options);
                    compressedFiles.push(compressedFile);
                    const preview = URL.createObjectURL(compressedFile);
                    filePreviews.push(preview);
                } catch (error) {
                    console.error('Error comprimiendo la imagen:', error);
                }
            }

            setFotos(compressedFiles);
            setPreviewFotos(filePreviews);
        } else {
            setPopupMensaje('Solo se pueden subir hasta 3 fotografías');
            setPopupKey(prevKey => prevKey + 1);
            // Limpiar el input de archivos
            e.target.value = null;

        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!titulo) {
            setPopupMensaje('Por favor llena todos los campos');
            setPopupKey(prevKey => prevKey + 1);
            return;
        }

        if (fotos.length === 0) {
            setPopupMensaje('Por favor sube al menos una foto');
            setPopupKey(prevKey => prevKey + 1);
            return;
        }

        let ubicacion = '';
        switch (ubicacionTipo) {
            case 'actual':
                if (!ubicacionActual) {
                    setPopupMensaje('Por favor obtén tu ubicación actual');
                    setPopupKey(prevKey => prevKey + 1);
                    return;
                }
                ubicacion = ubicacionActual;
                break;
            case 'mapa':
                if (!mapaCoords) {
                    setPopupMensaje('Por favor selecciona una ubicación en el mapa');
                    setPopupKey(prevKey => prevKey + 1);
                    return;
                }
                ubicacion = `Lat: ${mapaCoords.lat}, Lng: ${mapaCoords.lng}`;
                break;
            default:
                setPopupMensaje('Selecciona un método de ubicación válido');
                setPopupKey(prevKey => prevKey + 1);
                return;
        }

        const formData = new FormData();
        formData.append('titulo', titulo);
        formData.append('descripcion', descripcion || 'Sin descripción');
        formData.append('coordenadas', ubicacion);
        formData.append('estatus', 'Capturado');
        formData.append('userID', isLogged ? id : 0);
        formData.append('tipo', 'Posible Delito');
        formData.append('telefono', telefonoOp || telefono);
        for (let i = 0; i < fotos.length; i++) {
            console.log(`Imagen ${i}:`, fotos[i]);
            formData.append('imagenes', fotos[i]);
        }

        try {
            setLoading(true);
            const res = await createReporte({ token, formData });
            if (res.success) {
                setPopupMensaje(`Reporte creado exitosamente.\nN. folio: ${res.data.id}`);
                setPopupKey(prevKey => prevKey + 1);
                setTitulo('');
                setDescripcion('');
                setFotos([]);
                setPreviewFotos([]);
                setTituloSeleccionado('');
                setUbicacionActual('');
            } else {
                setPopupMensaje("Error al crear el reporte");
            }
        } catch (error) {
            console.error('Error de red:', error);
            setPopupMensaje('Error al crear el reporte, intenta de nuevo más tarde');
            setPopupKey(prevKey => prevKey + 1);
        } finally {
            setLoading(false)
        }
    };
    const handlePopupClose = () => {
        setPopupMensaje('');
    };
    return (
        <div className='main'>
            <div className='titulo-componentes'>Solicitar atención o denunciar posible delito</div>
            <div className='contenido-componentes'>
                {loading ? (
                    <Loader />
                ) : (
                    <form className='crear-denuncia-form' onSubmit={handleSubmit}>
                        <div className='crear-denuncia-space'>
                            <label>Título del reporte (obligatorio)</label>
                            {tituloSeleccionado !== '' && (
                                <div className='crear-denuncia-titulo'>{tituloSeleccionado}</div>
                            )}
                            <div className='seccion-titulo'>Conectate a C4</div>
                            <div className='crear-denuncia-menu'>
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Chat vecinal' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={chatVecinal}
                                    alt='chat vecinal icono'
                                    onClick={() => setTituloSeleccionado('Chat vecinal')} />
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Conecta tu cámara' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={conectaTuCamara}
                                    alt='conecta tu camara icono'
                                    onClick={() => setTituloSeleccionado('Conecta tu cámara')} />
                            </div>
                            <div className='seccion-titulo'>Denuncia</div>
                            <div className='crear-denuncia-menu'>
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Robo' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={robo}
                                    alt='robo icono'
                                    onClick={() => setTituloSeleccionado('Robo')} />
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Venta de droga' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={ventaDeDroga}
                                    alt='venta de droga icono'
                                    onClick={() => setTituloSeleccionado('Venta de droga')} />
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Extorsión' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={extorsion}
                                    alt='denuncia extorsion icono'
                                    onClick={() => setTituloSeleccionado('Extorsión')} />
                            </div>
                            <div className='seccion-titulo'>Servicio Policial</div>
                            <div className='crear-denuncia-menu'>
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Reunión vecinal' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={reunionVecinal}
                                    alt='reunion vecinal icono'
                                    onClick={() => setTituloSeleccionado('Reunión vecinal')} />
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Rondines de seguridad' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={rondinesDeSeguridad}
                                    alt='rondines de seguridad icono'
                                    onClick={() => setTituloSeleccionado('Rondines de seguridad')} />
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Acompañamiento bancario' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={acompanamietoBancario}
                                    alt='acompañamiento bancario icono'
                                    onClick={() => setTituloSeleccionado('Acompañamiento bancario')} />
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Vehículos abandonados' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={vehiculosAbandonados}
                                    alt='vehiculos abandonados icono'
                                    onClick={() => setTituloSeleccionado('Vehículos abandonados')} />
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Solicita una cámara' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={solicitaUnaCamara}
                                    alt='solicita una camara icono'
                                    onClick={() => setTituloSeleccionado('Solicita una cámara')} />
                            </div>
                            <div className='crear-denuncia-menu'>
                                <img className={`icono-menu-img ${tituloSeleccionado === 'Otro' ? 'destacar-titulo-seleccionado' : ''}`}
                                    src={otros}
                                    alt='otros icono'
                                    onClick={() => setTituloSeleccionado('Otro')} />
                            </div>
                            {mostrarInput && (
                                <input
                                    ref={otroDelitoRef}
                                    type='text'
                                    value={titulo}
                                    onChange={(e) => setTitulo(e.target.value)}
                                    required
                                    placeholder='Escribe aquí el título del reporte'
                                    className='crear-denuncia-input-otro'
                                />
                            )}
                        </div>
                        <div className='crear-denuncia-space'>
                            <label>Descripción de los hechos </label>
                            <textarea
                                ref={descripcionRef}
                                className='crear-denuncia-descripcion'
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}
                                placeholder='Escribe aquí la descripción de los hechos'
                            ></textarea>
                        </div>
                        <div className='crear-denuncia-space'>
                            <label>Ubicación del reporte (obligatorio)</label>
                            <div className="ubicacion-selector">
                                <label>
                                    <input
                                        type="radio"
                                        name="ubicacionTipo"
                                        checked={ubicacionTipo === 'actual'}
                                        onChange={() => setUbicacionTipo('actual')}
                                    />
                                    Actual
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="ubicacionTipo"
                                        checked={ubicacionTipo === 'mapa'}
                                        onChange={() => setUbicacionTipo('mapa')}
                                    />
                                    Seleccionar
                                </label>
                            </div>

                            {ubicacionTipo === 'actual' && (
                                <div className='contenedor-vertical'>
                                    <button
                                        type="button"
                                        className='boton-secundario'
                                        onClick={obtenerUbicacionActual}
                                    >
                                        Obtener Ubicación
                                    </button>
                                    <br />
                                    {ubicacionActual && (
                                        <div className='titulo-componentes'>
                                            {ubicacionActual}
                                        </div>
                                    )}
                                </div>
                            )}
                            {ubicacionTipo === 'mapa' && (
                                <div className="mapa-seleccion">
                                    <div className="mapa-container">
                                        <MapContainer
                                            center={[19.7000, -101.1833]}
                                            zoom={12}
                                            style={{ height: '400px', width: '100%' }}
                                        >
                                            <TileLayer url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}" />

                                            <MapClickHandler onMapClick={handleMapClick} />
                                            {mapaCoords && (
                                                <Marker position={[mapaCoords.lat, mapaCoords.lng]} />
                                            )}
                                        </MapContainer>
                                    </div>
                                    <br />
                                    {mapaCoords && (
                                        <div className='titulo-componentes'>
                                            Lat: {mapaCoords.lat.toFixed(6)}, Lng: {mapaCoords.lng.toFixed(6)}
                                        </div>
                                    )}
                                </div>
                            )}

                        </div>

                        <div className='crear-denuncia-space'>
                            <label>Fotografías (máximo 3, obligatorio) *</label>
                            {previewFotos.length > 0 && (
                                <div className='crear-denuncia-fotos'>
                                    {previewFotos.map((foto, index) => (
                                        <img
                                            key={index}
                                            className='crear-denuncia-foto'
                                            src={foto}
                                            alt={`Foto ${index + 1}`}
                                        />
                                    ))}
                                </div>
                            )}
                            <label className="custom-file-upload">
                                <input
                                    type='file'
                                    multiple
                                    accept='image/*'
                                    onChange={handleFileChange}
                                />
                                Seleccionar fotos
                                <img className='icono-imagen' src={imagen} alt='imagen icono' />
                            </label>
                        </div>

                        {telefono !== '' ? null : (
                            <div className='crear-denuncia-space'>
                                <label>¿Deseas recibir actualización de tu reporte? Déjanos tu número de telefono</label>
                                <input
                                    type="text"
                                    value={telefonoOp}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, ''); // Solo dígitos
                                        if (value.length <= 10) setTelefonoOp(value);     // Máx. 10 caracteres
                                    }}
                                    placeholder="Escribe aquí tu número de teléfono"
                                    className="crear-denuncia-input-otro"
                                />
                            </div>
                        )}

                        <div className='contenerdor-btn-enviar'>
                            <button className='boton-primario' type='submit'>Enviar reporte</button>
                        </div>
                    </form>
                )}
            </div>
            {popupMensaje && (
                <PopupMensaje
                    key={popupKey}
                    mensaje={popupMensaje}
                    onClose={handlePopupClose}
                />
            )}
        </div>
    );
};

export default Delito;